// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e95a23024c268a73066e","777":"e77097c9cc0f1ff4a97d","939":"c22c38f0049a47354d59"}[chunkId] + ".js";
};